module.exports = __webpack_public_path__ + "img/digital.3ea4df45.png";